import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDialogData {
  type: 'noButtons' | 'okButton' | 'okDismissButton';
  title?: string;
  message?: string;
  okButtonText?: string;
  dismissButtonText?: string;
  confirmColor?: string;
  cancelColor?: string;
}

export interface IDialogFeedback {
  error: {
    title: string;
    message: string;
  };
  success: {
    title: string;
    message: string;
  };
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent {
  dialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  data = inject<IDialogData>(MAT_DIALOG_DATA);

  constructor() {
    const data = this.data;

    if (!data.confirmColor) {
      this.data.confirmColor = 'primary';
    }
    if (!data.cancelColor) {
      this.data.cancelColor = 'warn';
    }
  }

  public onOk() {
    this.dialogRef.close(true);
  }

  public onDismiss() {
    this.dialogRef.close(false);
  }
}
